<template>
  <div id="app">

    <router-view :key="this.currentOrgId"></router-view>

    <md-snackbar :md-position="'bottom right'" ref="snackbar2" :md-duration="6000">
      <span v-for="item in snackbar.errors" :key="item"> {{ item.message }}</span>
      <md-button class="md-primary" @click.native="$refs.snackbar.close()">Ok</md-button>
    </md-snackbar>

    <md-snackbar :md-position="vertical + ' ' + horizontal" ref="snackbar" :md-duration="duration">
      <span>{{ sMessage | translate }}.</span>
      <md-button :class="snackbarStyle" @click="$refs.snackbar.close()">Ok</md-button>
    </md-snackbar>

    <md-dialog-confirm
      :md-title="'global.~ALERTA~' | translate"
      :md-content-html="dMessage | translate"
      :md-ok-text="'global.~ACEPTAR~' | translate"
      :md-cancel-text="'global.~CANCELAR~' | translate"
      @close="onClose"
      ref="confirmMessage">
    </md-dialog-confirm>

    <md-dialog-alert
      :md-title="'global.~ALERTA~' | translate"
      :md-content="dMessage | translate"
      :md-ok-text="'global.~ACEPTAR~' | translate"
      @close="onClose"
      ref="dialogAlert">
    </md-dialog-alert>
  </div>
</template>

<script>

import VueBase64FileUpload from 'vue-base64-file-upload'
import Tour from 'tour/dist/tour.js'
import axios from 'axios'
import { mapState } from 'vuex'

if (!axios.defaults.headers.common['Authorization']) axios.defaults.headers.common['Authorization'] = localStorage.getItem('feathers-jwt')

export default {
  name: 'app',
  data: function () {
    return {
      speedDial: false,
      routesFalse: [
        'Main', 'Login'
      ],
      currentUserData: {},
      snackbar: {
        errors: [],
        events: []
      },
      audioFormIsVisible: false,
      fileData: {
        fileName: '',
        uri: '',
        fileType: 'audio',
        friendlyName: '',
        size: 0
      },
      fileName: '',
      customImageMaxSize: 3, // megabytes
      search: '',
      nombreElemento: '',
      buttonSave: true,
      dialogTemp: '',
      dialogMessage: ' ',
      snackbarMessage: ' ',
      snackbarStyle: 'md-primary',
      vertical: 'bottom',
      horizontal: 'center',
      duration: 3000
    }
  },
  components: {
    VueBase64FileUpload
  },
  computed: {
    ...mapState({
      currentOrgId: state => state.authentication.currentOrgId
    }),
    dMessage: function () {
      return this.dialogMessage
    },
    sMessage: function () {
      return this.snackbarMessage
    }
  },
  created () {
    this.$store.dispatch('getRoles')
    this.local = this.$i18n.locale()
    this.$validator.localize(this.local)
    this.$material.setCurrentTheme('global')
    this.$store.dispatch('listPeers')
  },
  mounted () {
    this.$events.$on('snackbar-message', (eventData) => {
      this.snackbarMessage = eventData.message
      this.snackbarStyle = eventData.style
      this.$refs.snackbar.open()
    })
    this.$events.$on('open-dialog', (eventData) => {
      this.dialogTemp = eventData.return
      this.dialogMessage = eventData.message
      if (eventData.element) {
        this.openDialog(eventData.element)
      }
    })
    this.$events.$on('active-help', (eventData) => {
      this.activeHelp(eventData)
    })
  },
  beforeDestroy () {
    this.$events.$off('active-help')
    this.$events.$off('open-dialog')
    this.$events.$off('snackbar-message')
  },
  methods: {
    isMobileDevice () {
      // return true
      return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    activeHelp (value) {
      this.$store.commit('CHANGE_ACTIVE_HELP', value)
      if (this.$store.state.tour.activeHelp) {
        this.runTourNow(this.$store.state.tour.current.data)
      }
    },
    runTourNow (data) {
      Tour.start(data).then(() => {
        this.$store.commit('CHANGE_ACTIVE_HELP', false)
        this.$store.commit('SET_VIEWED_VALUE', data.name)
      }).catch((value) => {
        this.$events.$emit('close-user-card', true)
        this.$store.commit('CHANGE_ACTIVE_HELP', false)
        this.$store.commit('SET_VIEWED_VALUE', data.name)
      })
    },
    openDialog (ref) {
      if (ref) {
        this.$refs[ref].open()
      }
    },
    closeDialog (ref) {
      this.$refs[ref].close()
    },
    onClose (type) {
      if (type === 'ok') {
        this.$events.$emit(this.dialogTemp, true)
      }
    },
    open () {
      this.$refs.snackbar.open()
    }
  }
}
</script>

<style lang="scss">
@import './stylesheets/variables.scss';

$sizebar-size: 280px;

[v-cloak] {
  display: none;
}

html,
body {
  height: 100%;
  overflow: hidden;
}

body {
  display: flex;
}

.container {
  min-height: 100%;
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
  transition: $swift-ease-out;
  @media (min-width: 1281px) {
    padding-left: $sizebar-size;
  }
}

.main-sidebar.md-sidenav {
  .md-sidenav-content {
    width: $sizebar-size;
    display: flex;
    flex-flow: column;
    overflow: hidden;
    @media (min-width: 1281px) {
      top: 0;
      pointer-events: auto;
      transform: translate3d(0, 0, 0) !important;
      box-shadow: $material-shadow-2dp;
    }
  }
  .md-backdrop {
    @media (min-width: 1281px) {
      opacity: 0;
      pointer-events: none;
    }
  }
  .md-toolbar {
    min-height: 172px;
    border-bottom: 1px solid rgba(#000, .12);
  }
  .vue-material-logo {
    font-size: 24px;
    a {
      width: 100%;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      color: inherit;
      text-decoration: none;
      &:hover {
        color: inherit;
        text-decoration: none;
      }
    }
    img {
      width: 160px;
      margin-bottom: 16px;
    }
  }
  .main-sidebar-links {
    overflow: auto;
    flex: 1;
    .md-inset .md-list-item-container {
      padding-left: 36px;
    }
    .md-list-item-container {
      font-size: 14px;
      font-weight: 500;
    }
  }
  .release-version {
    padding: 8px 8px 8px 16px;
    border-top: 1px solid rgba(#000, .12);
    display: none;
    @media (max-width: 480px) {
      display: block;
    }
    >div {
      justify-content: center;
    }
    .md-select:after {
      color: rgba(#000, .87);
    }
  }
}

.main-content {
  padding: 16px;
  flex: 1;
  overflow: auto;
  background-color: #fff;
  transform: translate3D(0, 0, 0);
  transition: $swift-ease-out;
  transition-delay: .2s;
}

.md-router-enter,
.md-router-leave {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  @media (min-width: 1281px) {
    left: $sizebar-size;
  }
  .main-content {
    opacity: 0;
    overflow: hidden;
  }
}

.md-router-leave {
  z-index: 1;
  transition: $swift-ease-in;
  transition-duration: .25s;
}

.md-router-enter {
  z-index: 2;
  transition: $swift-ease-out;
  .main-content {
    transform: translate3D(0, 10%, 0);
  }
}

code {
  &:not(.hljs) {
    margin-left: 1px;
    margin-right: 1px;
    padding: 0 4px;
    display: inline-block;
    border-radius: 2px;
    font-family: "Operator Mono", "Fira Code", Menlo, Hack, "Roboto Mono", "Liberation Mono", Monaco, monospace;
    pre {
      margin: 8px 0;
    }
  }
}

.phone-viewport {
  width: 360px;
  height: 540px;
  margin-right: 16px;
  display: inline-block;
  position: relative;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid rgba(#000, .12);
}

.api-table tr>td:first-child {
  white-space: nowrap;
}

.md-button {
  text-transform: none !important;
}

.md-card {
  width: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex: 1;
}

.noShadow {
  width: 100%;
  min-height: 740px !important;
  background-color: #bbb !important;
  border-radius: 0px !important;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .0s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(6px);
  opacity: 0;
}

.fade-enter-active {
  transition: all .5s ease;
}

.fade-leave-active {
  transition: all .2s ease;
}

.fade-enter, .fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  opacity: 0;
  transform: translateY(5px);
}

.md-input-container label {
  font-size: 14px !important;
}

.md-input-container {
  margin: 0px 0 12px !important;
  padding-top: 16px !important;
  font-size: 14px !important;
}

.md-input-container.md-has-value input, .md-input-container.md-has-value textarea, .md-select .md-select-value {
  font-size: 14px !important;
}

.md-input-container.md-has-value label, .md-input-container.md-input-focused label{
  font-size: 12px !important;
}

.md-input-container.md-input-placeholder input, .md-input-container.md-input-placeholder textarea {
    font-size: 14px !important;
}

.myDialogContent{
  padding: 0px !important;
}

.myDialogTitle {
  margin-bottom: 5px !important;
  padding: 16px 16px 0 !important;
}

.v1 {
  font-size: 15px !important;
  width: 100% !important;
}

.v1-input {
  width: 100% !important;
  font-size: 15px !important;
}

.md-button-add-custom {
    margin: 0px !important;
}

.ip-spinner{
  float: right;
  margin-left: 6px;
  margin-top: 6px;
  color: #ffffff !important;
}

.ip-spinner2{
  float: left;
  margin-left: 2px;
  margin-top: 0px;
  color: #ffffff !important;
}

.md-input-container .md-error, .md-input-container .md-count {
  height: 20px !important;
  position: absolute !important;
  bottom: -16px !important;
  font-size: 10px !important;
}

.custom-delete {
  min-height: 26px !important;
  height: 30px !important;
  width: 30px !important;
  min-width: 30px !important;
  margin: 0px !important;
  font-size: 20px !important;
}

.vdp-datepicker__calendar .cell {
  height: 28px !important;
  line-height: 28px !important;
  z-index: 10000;
}

.vdatetime-popup {
  z-index: 1000 !important;
  position: absolute !important;
  margin-top: -40px !important;
  top: -20px !important;
  left: 0 !important;
  max-width:260px !important;
  max-height: 400px !important;
}

.vdatetime-calendar__navigation {
  margin: 5px 0 !important;
}

.vdatetime-calendar__month__weekday, .vdatetime-calendar__month__day {
  line-height: 16px !important;
    font-size: 13px !important;
}

.vdatetime-year-picker__list {
  height: 260px !important;
}

.vdatetime-popup__header,
.vdatetime-popup__date-picker__item--selected > span > span,
.vdatetime-popup__date-picker__item--selected:hover > span > span {
  background: #1e88e5 !important;
}

.vdatetime-popup__list-picker__item--selected,
.vdatetime-popup__actions__button {
  color: #1e88e5 !important;
}

.custom-font{
  font-size: 14px !important;
  cursor: pointer !important;
  font-family: unset !important;
  color: #000 !important;
}

.pointer-cursor{
  cursor:pointer;
}

#insertAudioForm{
  min-width: 308px !important;
}

.md-table-cell-container .md-button[disabled] .md-icon, .md-button[disabled] .md-icon{
  color: #cccccc !important;
  cursor: default !important;
  pointer-events: none !important;
}

.ip-error {
  text-align: center !important;
  color: #dd2233 !important;
  width: 100% !important;
  font-weight: 500 !important;
  background-color: #ffdddd !important;
  border: solid thin #eeaaaa !important;
  padding: 8px !important;
  border-radius: 4px !important;
}

.custom-progress .md-progress-track {
  background-color: #22cc77 !important;
}

fieldset {
  border: unset !important;
  padding: unset !important;
  margin: unset !important;
}

fieldset[disabled] .md-input-container:after {
  background: bottom left repeat-x !important;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.38) 0%, rgba(0, 0, 0, 0.38) 33%, transparent 0%) !important;
  background-size: 4px 1px !important;

}

fieldset[disabled] .md-input{
  color: rgba(0, 0, 0, .38) !important;
}

.mx-input {
  height: 26px !important;
  font-size: 12px !important;
  line-height: 1.4;
  border-radius: 0px;
  box-shadow: none;
}

.mx-datepicker {
  margin-left: auto !important;
  margin-right: auto !important;
}

.myCustomTable table {
  overflow: unset !important;
}

.myCustomTable {
  overflow-x: unset !important;
}

.myCustomCard {
  overflow: unset !important;
  z-index: unset !important;
}

.spinner-position{
  height: 150px !important;
}

.custom-list .md-list-item-container {
  padding: 0 8px !important;
}

.multiselect__tags {
  border-radius: 0px !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid #e8e8e8 !important;
  font-size: 13px !important;
  padding: 0px 40px 0px 0px !important;
  min-height: 20px !important;
}

.multiselect__tag {
  border-radius: 0px !important;
  background: #1e88e5 !important;
}

.multiselect__tag-icon:hover {
  background: #e65a5a !important;
}

.multiselect__option--highlight {
  background: #1e88e5 !important;
  outline: none !important;
  color: #ffffff !important;
  z-index: 1000000;
}

.multiselect__option--highlight:after {
  content: attr(data-select) !important;
  background: #1e88e5 !important;
  color: #ffffff !important;
}

.typo__label{
  position: relative;
  margin-top: 14px !important;
  font-size: 12px !important;
  color: #777777 !important;
}

.multiselect__single {
  padding-left: 0px !important;
  margin-bottom: 5px !important;
  padding: 0 0 0 0px !important;
}

.multiselect__select {
  height: 28px !important;
}

.multiselect--disabled .multiselect__select {
  background: none !important;
}

.multiselect--disabled {
  background: none !important;
}

.custom-dialog div.md-dialog{
  min-width: 600px !important;
  max-width: 600px !important;
  min-height: 460px !important;
}

.multiselect__single, {
  font-size: 13px !important;
}

.custom-table-top{
  margin-top: -7px;

  .md-table-cell-container{
    padding: 6px 4px 6px 4px !important;
  }
}

</style>



// WEBPACK FOOTER //
// App.vue?79c09b78